module.exports = __webpack_public_path__ + "static/media/equip-use.4357ba72.jpg";